import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { MFieldProps } from '../types';
import { ApiAutocomplete as CoreApiAutocomplete } from '@mc/react-autocomplete';
import { useTheme } from '../useTheme';
import { FormItem } from './FormItem';
import classNames from 'classnames';

export type ApiAutocompleteProps = MFieldProps<
  React.ComponentProps<typeof CoreApiAutocomplete>
>;
export const ApiAutocomplete = React.forwardRef<
  HTMLInputElement,
  ApiAutocompleteProps
>(
  (
    { name, validate, className, inputClassName, disabled, required, ...other },
    ref
  ) => {
    const { ns } = useTheme();
    return (
      <FormItem
        name={name}
        className={className}
        required={required}
        disabled={disabled}
      >
        <Field name={name}>
          {({
            input: { value, onBlur: $onBlur, onChange: $onChange },
          }: FieldRenderProps<any>) => {
            return (
              <CoreApiAutocomplete
                {...other}
                disabled={disabled}
                className={classNames(`${ns}-autocomplete`, inputClassName)}
                onChange={(value) => {
                  $onChange({ target: { name, value } });
                  other.onChange?.({ target: { name, value } });
                }}
                onBlur={(value) => {
                  $onBlur({
                    target: { name, value },
                  } as any as React.FocusEvent<HTMLElement>);
                  other.onBlur?.({ target: { name, value } });
                }}
                value={value}
                // @ts-ignore
                ref={ref}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
